const EMPTY_LITERALS = new Set(["null", "undefined"]);

/**
 * Sanitizes a single order note value for display and API payloads.
 * @param {unknown} value
 * @returns {string}
 */
export function sanitizeOrderNote(value) {
  if (value == null) return "";
  const trimmed = String(value).trim();
  if (!trimmed || EMPTY_LITERALS.has(trimmed.toLowerCase())) return "";
  return trimmed;
}

/**
 * Builds notasEntrega for venta creation. Returns undefined when there is no real note.
 * @param {unknown} orderNotes
 * @param {{ includeDiscount022024?: boolean }} [options]
 * @returns {string|undefined}
 */
export function buildNotasEntrega(orderNotes, options = {}) {
  const parts = [];
  const note = sanitizeOrderNote(orderNotes);
  if (note) parts.push(note);
  if (options.includeDiscount022024) {
    parts.push("Código de descuento: 022024");
  }
  const combined = parts.join(" ").trim();
  return combined || undefined;
}
